import "./single-satellite.scss";
import "../../../js/core";
import "../../../components/site-elements/other-blocks/collapse-tabs/collapse-tabs";
import "../../../js/compare-slider";

// Slider
$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      jQuery(".js-slider-compare").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          768: {
            items: 1,
            dots: true,
          },
        },
        loop: false,
        smartSpeed: 800,
        nav: true,
        dots: true,
        margin: 50,
        mouseDrag: false,
        touchDrag: false,
        pullDrag: false,
        smartSpeed: 200,
      });

      jQuery(".js-slider-benefits").owlCarousel({
        responsive: {
          0: {
            items: 1,
            mouseDrag: true,
            touchDrag: true,
          },
          650: {
            items: 2,
            mouseDrag: true,
            touchDrag: true,
          },
          1241: {
            items: 3,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
          },
        },

        loop: false,
        smartSpeed: 800,
        nav: true,
        dots: false,
        margin: 20,
        mouseDrag: false,
        touchDrag: false,
        smartSpeed: 200,
      });

      $(".owl-carousel").each(function (index) {
        $(this)
          .find(".owl-nav, .owl-dots")
          .wrapAll("<div class='owl-controls'></div>");
      });
    });
  });
});
